import {Component, inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {SelectMultipleComponent} from '../../../../shared/components/select-multiple/select-multiple.component';
import {FormFieldComponent} from '../../../../shared/components/form-field/form-field.component';
import {ButtonPadraoComponent} from '../../../../shared/components/button-padrao/button-padrao.component';
import { DisparoAutomaticoFiltro, OpcaoFiltroDisparo } from '../../../../shared/model/disparo-automatico/disparo-automatico-filtro.model';
import { STATUS_DISPARO_OPCOES } from '../../../../shared/model/disparo-automatico/status-disparo.util';
import {ProgramacaoDisparoService} from '../../../../shared/service/programacao-disparo.service';
import {UsuarioService} from '../../../../shared/service/usuario.service';
import {SetorService} from '../../../../shared/service/setor.service';
import {ContaService} from '../../../../shared/service/conta.service';
import {FluxoService} from '../../../../shared/service/fluxo-service';

@Component({
  selector: 'app-modal-filtro-disparo',
  standalone: true,
  imports: [SelectMultipleComponent, FormFieldComponent, ButtonPadraoComponent],
  templateUrl: './modal-filtro-disparo.component.html',
  styleUrl: './modal-filtro-disparo.component.css'
})
export class ModalFiltroDisparoComponent implements OnInit {
  filtro!: DisparoAutomaticoFiltro;
  programacoes: OpcaoFiltroDisparo[] = [];
  usuarios: OpcaoFiltroDisparo[] = [];
  setores: OpcaoFiltroDisparo[] = [];
  contas: OpcaoFiltroDisparo[] = [];
  fluxos: OpcaoFiltroDisparo[] = [];
  carregando = true;

  private static readonly TODOS_ID = 'TODOS';

  readonly statusDisparos: OpcaoFiltroDisparo[] = [
    { id: ModalFiltroDisparoComponent.TODOS_ID, nome: 'Todos' },
    ...STATUS_DISPARO_OPCOES
  ];

  readonly statusProgramacoes: OpcaoFiltroDisparo[] = [
    {id: 'RECORRENTE', nome: 'Recorrente'},
    {id: 'AGENDADO', nome: 'Agendado'},
    {id: 'CANCELADO', nome: 'Cancelado'}
  ];

  private readonly dialogRef = inject(MatDialogRef<ModalFiltroDisparoComponent>);
  readonly data = inject<{
    filtro: DisparoAutomaticoFiltro;
    statusGroup: 'DISPAROS' | 'PROGRAMACOES';
  }>(MAT_DIALOG_DATA);
  private readonly programacaoService = inject(ProgramacaoDisparoService);
  private readonly usuarioService = inject(UsuarioService);
  private readonly setorService = inject(SetorService);
  private readonly contaService = inject(ContaService);
  private readonly fluxoService = inject(FluxoService);

  ngOnInit(): void {
    this.filtro = DisparoAutomaticoFiltro.copiar(this.data.filtro);
    let pendentes = 5;
    const concluir = () => this.carregando = --pendentes > 0;
    this.programacaoService.buscarProgramacoesAtivas().subscribe({
      next: itens => {
        this.programacoes = itens as OpcaoFiltroDisparo[];
        const idsSelecionados = new Set(this.filtro.programacoes.map(item => Number(item.id)));
        this.filtro.programacoes = this.programacoes.filter(item => idsSelecionados.has(Number(item.id)));
      },
      complete: concluir
    });
    this.usuarioService.buscarUsuarios().subscribe({
      next: itens => this.usuarios = itens as OpcaoFiltroDisparo[], complete: concluir
    });
    this.setorService.buscarSetoresSelectAtivo().subscribe({
      next: itens => this.setores = itens as OpcaoFiltroDisparo[], complete: concluir
    });
    this.contaService.buscarTodosNumerosAtivos().subscribe({
      next: itens => this.contas = itens as OpcaoFiltroDisparo[], complete: concluir
    });
    this.fluxoService.buscar().subscribe({
      next: itens => this.fluxos = itens as OpcaoFiltroDisparo[], complete: concluir
    });
  }

  get statusOpcoes(): OpcaoFiltroDisparo[] {
    return this.data.statusGroup === 'PROGRAMACOES' ? this.statusProgramacoes : this.statusDisparos;
  }

  selecionarStatus(selecionados: OpcaoFiltroDisparo[]): void {
    const clicouTodos = selecionados.some(item => item.id === ModalFiltroDisparoComponent.TODOS_ID);
    if (!clicouTodos) {
      this.filtro.status = selecionados;
      return;
    }

    const opcoesReais = this.statusOpcoes.filter(item => item.id !== ModalFiltroDisparoComponent.TODOS_ID);
    const todasJaSelecionadas = opcoesReais.every(opcao =>
      this.filtro.status.some(selecionado => selecionado.id === opcao.id));
    this.filtro.status = todasJaSelecionadas ? [] : [...opcoesReais];
  }

  salvar(): void {
    this.dialogRef.close(this.filtro);
  }

  cancelar(): void {
    this.dialogRef.close(null);
  }
}
